<script>
	const Marklib = require('marklib');
	const _ = require('underscore');
	const pubsub = require('events/pubsub');
	const HTMLUtil = require('utilities/html');
	const Cursor = require('utilities/cursor');
	const Store = require('kvstore');
	const optimizedResize = require('utilities/optimizedResize');
	const breakpoints = require('utilities/breakpoints');
	const logger = require('utilities/logger');
	let idCounter = 1;

	module.exports = {
		props: {
			highlights: {
				required: true,
				type: Array
			},
			content: {
				required: true
			},
			allowEdit: {
				type: Boolean
			},
			minimal: {
				required: false,
				type: Boolean
			},
			forceMobile: {
				required: false,
				type: Boolean
			},
			splitScreen: {
				required: false,
				type: Boolean
			}
		},
		data() {
			return {
				defaultStyle: 'o',
				converter: null,
				id: '',
				unsubUpdateStyle: null,
				unsubPrompt: null,
				unsubFontSize: null,
				highlightPositions: [],
				showingPrompt: null,
				lastElHeight: undefined,
				correctedSelectionRange: null,
				mobileFlagTriggered: false
			};
		},
		computed: {
			offsetParent() {
				const el = this.$el;

				if (!HTMLUtil.isDescendant(el, document.body)) {
					const p = getComputedStyle(el).position;

					if (['relative', 'absolute', 'fixed'].includes(p)) {
						return el;
					} else {
						return el.parentElement;
					}
				} else {
					return el.parentElement;
				}
			},
			isPromptForExistingHighlight() {
				return this.showingPrompt !== null && this.showingPrompt < this.highlights.length;
			},
			isTextSelected() {
				const sel = window.getSelection();

				if (!sel.toString().trim()) {
					return false;
				}

				const range = sel.getRangeAt(0);

				if (!HTMLUtil.isDescendant(range.startContainer, this.$el) || !HTMLUtil.isDescendant(range.endContainer, this.$el)) {
					return false;
				}

				return true;
			}
		},
		methods: {
			hidePrompt() {
				this.showingPrompt = null;
				this.$refs.prompt.hide();
				if (this.id) {
					pubsub.publish('annotation-prompt-close-' + this.id);
				}
			},
			sendContentMessage(idx) {
				const hp = this.highlightPositions[idx];
				const $content = $('<span></span>');

				$('.marking[data-selection-id="' + hp.selectionId + '"]', this.$el)
					.contents()
					.each(function (i) {
						let $i = $(this);
						const flags = {};
						['em', 'strong', 'b'].forEach(function (tag) {
							if ($i.parents(tag).size() > 0) {
								flags[tag] = 1;
							}
						});

						if (Object.keys(flags).length === 0) {
							flags.span = 1;
						}

						$i = $i.clone();
						Object.keys(flags).forEach(function (tag) {
							tag = '<' + tag + '></' + tag + '>';
							$i = $i.wrap(tag).parent();
						});

						$content.append($i);
					});

				$content.find('x-marker').contents().unwrap('x-marker').wrap('<span></span>');

				pubsub.publish('annotation-content-' + this.id, {
					idx,
					content: '<span>' + $content.html() + '</span>'
				});
			},
			updateTops() {
				if (!this.content || this.highlights.length === 0) {
					return;
				}

				this.highlightPositions.forEach((h, idx) => {
					const newTop = $('.marking[data-selection-id="' + h.selectionId + '"]', this.$el)
						.first()
						.position().top;

					if (newTop !== h.selectionTop) {
						h.selectionTop = newTop;
						pubsub.publish('annotation-position-' + this.id, {
							top: newTop,
							idx: idx
						});
					}
				});
			},
			renderAllHighlights() {
				const el = this.$el;

				$(el).find('img').off('load');

				this.$refs.content.innerHTML = this.content;
				$(el).find('img').on('load', this.updateTops.bind(this));

				this.highlightPositions = [];

				this.highlights.forEach((h, idx) => {
					let indexes = {
						start: h.start,
						end: h.end
					};

					if (!h.version) {
						logger.info('legacy indexes', JSON.stringify(indexes));
						indexes = this.converter.fixLegacyIndexes(indexes);
						logger.info('fixed indexes to', JSON.stringify(indexes));
					}

					// even though we will add the ID to selectors below, we still need to use
					// el as the context parameter. Sometimes this renderAllHighlights
					// method can be invoked when el is not in the DOM, so without el
					// as a parameter renderWithResult will throw an Error.
					const ml = new Marklib.Rendering(
						document,
						{
							className: 'marking marking-' + h.style
						},
						this.$refs.content
					);
					const range = this.converter.indexesToRange(indexes);

					this.converter.ensureRangeContainersAreTextNodes(range);

					ml.renderWithRange(range);
					range.detach();

					this.highlightPositions.push(Object.assign(range, this.findNewestHighlightElementAndPosition()));
					this.sendContentMessage(idx);

					this.updateTops();
				});
			},
			getHighlightStartEndPositions(idx) {
				const hp = this.highlightPositions[idx];

				const $selectionEls = $('.marking[data-selection-id="' + hp.selectionId + '"]', this.$el);

				const range1 = document.createRange();
				const range2 = document.createRange();
				let foundFirst = false;
				let lastNode;

				$selectionEls.each(function () {
					HTMLUtil.iterateTextNodes(function (n) {
						if (!foundFirst) {
							foundFirst = true;
							range1.setStart(n, 0);
							range1.setEnd(n, n.textContent.length);
							return true;
						} else {
							return false;
						}
					}, this);
				});

				$selectionEls.each(function () {
					HTMLUtil.iterateTextNodes(function (n) {
						lastNode = n;
					}, this);
				});

				range2.setStart(lastNode, 0);
				range2.setEnd(lastNode, lastNode.textContent.length);

				const positions = this.getSelectionStartEndPositions(range1, range2);

				range1.detach();
				range2.detach();

				return positions;
			},
			getSelectionStartEndPositions(sel, range2) {
				let startRange;
				let endRange;

				if (range2) {
					startRange = sel;
					endRange = range2;
				} else {
					startRange = sel.getRangeAt(0).cloneRange();
					endRange = sel.getRangeAt(0).cloneRange();
				}

				startRange.collapse(true);
				endRange.collapse(false);

				// Safari doesn't work with getBoundingClientRect like other browsers
				// but getClientRects works
				var startRect = startRange.getClientRects();
				var endRect = endRange.getClientRects();

				// chrome randomly returns a 0 length array
				if (endRect.length === 0) {
					endRect = [endRange.getBoundingClientRect()];
				}

				if (startRect.length === 0) {
					let rect = startRange.getBoundingClientRect();
					if (rect.top === 0 && rect.left === 0) {
						if (endRect[0].top !== 0 && endRect.left !== 0) {
							rect = endRect[0];
						}
					}
					startRect = [rect];
				}

				const positions = {
					start: {
						// the top given by getBoundingClientRect is below the top of the
						// highlight in the browser, -6 is just about right for where the highlight
						// actually is. Safari and Chrome both do this. IE doesn't do it, so our
						// menus look a few pixels too high there.
						top: startRect[0].top + window.pageYOffset - 6,
						left: startRect[0].left + window.pageXOffset,
						bottom: startRect[0].bottom + window.pageYOffset,
						right: startRect[0].right + window.pageXOffset
					},
					end: {
						top: endRect[0].top + window.pageYOffset - 6,
						left: endRect[0].left + window.pageXOffset,
						bottom: endRect[0].bottom + window.pageYOffset,
						right: endRect[0].right + window.pageXOffset
					}
				};

				// adjust for position:relative wrapper around component
				const offset = $(this.offsetParent).offset();

				positions.start.top -= offset.top;
				positions.end.top -= offset.top;
				positions.start.bottom -= offset.top;
				positions.end.bottom -= offset.top;
				positions.start.left -= offset.left;
				positions.end.left -= offset.left;
				positions.start.right -= offset.left;
				positions.end.right -= offset.left;

				return positions;
			},
			findNewestHighlightElementAndPosition: function () {
				let info = {};
				let known = {};

				this.highlightPositions.forEach(function (p) {
					known[p.selectionId] = 1;
				});

				$('.marking[data-selection-id]', this.$el).each(function () {
					const id = this.dataset.selectionId;
					if (!known[id] && !info.selectionId) {
						info.selectionId = id;
					}
				});

				return info;
			},
			positionPromptAround(what) {
				if (!this.allowEdit) {
					return;
				}
				let positions;
				if (typeof what === 'number') {
					logger.info('positionPromptAround invoked with', what);
					this.showingPrompt = what;
					positions = this.getHighlightStartEndPositions(what);
				} else {
					logger.info('positionPromptAround invoked with', what.toString());
					positions = this.getSelectionStartEndPositions(what);
				}

				positions.offsetParent = this.offsetParent;
				positions.contentElement = this.$el;

				this.$refs.prompt.show(positions, this.highlights[this.showingPrompt] || null);

				pubsub.publish('annotation-prompt-open-' + this.id, this.showingPrompt);
			},
			promptEditExistingHighlight(ev) {
				if (!this.allowEdit) {
					this.hidePrompt();
					return;
				}

				if (ev) {
					this.hidePrompt();

					let clickedId = ev.target.dataset.selectionId;

					if (!clickedId) {
						clickedId = $(ev.target).parents('x-marker[data-selection-id]').attr('data-selection-id');
					}

					// find the data selection that corresponds to the event
					const foundAnnotation = this.highlightPositions.findIndex((hp, idx) => clickedId === hp.selectionId);

					if (foundAnnotation !== -1) {
						this.positionPromptAround(foundAnnotation);
					}
				} else {
					this.positionPromptAround(this.showingPrompt);
				}
			},
			addNewHighlight(rg, style) {
				// process a new range from
				const ml = new Marklib.Rendering(
					document,
					{
						className: 'marking marking-' + style
					},
					this.$refs.content
				);

				// IE Edge likes to give us ranges that end with non-text nodes.
				// Marklib can't handle these correctly, so we'll filter now
				this.converter.ensureRangeContainersAreTextNodes(rg);

				let result = ml.renderWithRange(rg);

				result = result.serialize();
				const h = this.converter.rangeToIndexes(result);
				h.style = style;
				h.id = 'new' + idCounter++;
				h.created = new Date().getTime() / 1000.0;
				h.version = 2;

				const dupe = this.highlights.findIndex(existing => existing.start === h.start && existing.end === h.end);

				if (dupe > -1) {
					this.showingPrompt = dupe;
					this.updateAnnotationStyle(this.showingPrompt, style);

					// we just added a dupe to the DOM, so get rid of it with a re-render
					this.renderAllHighlights();
				} else {
					this.highlights.push(h);
					this.highlightPositions.push(Object.assign(result, this.findNewestHighlightElementAndPosition()));
					this.sendContentMessage(this.showingPrompt);
					pubsub.publish('annotation-create-' + this.id, h);
					this.updateTops();
				}

				// strangely, selections go haywire after we modify the DOM, so deselect all now
				// (the highlighting has been created, so we don't need the selection anymore)
				window.getSelection().removeAllRanges();

				this.positionPromptAround(this.showingPrompt);
			},
			selectWholeWords() {
				// see http://stackoverflow.com/questions/7380190/select-whole-word-with-getselection
				//
				const parent = this.$el;
				const sel = window.getSelection();

				if (!sel.toString()) {
					if (this.correctedSelectionRange) {
						this.correctedSelectionRange.detach();
						this.correctedSelectionRange = null;
					}
					return;
				}

				if (sel.isCollapsed) {
					// if selection is 1 point, then we don't need this
					return;
				}

				if (!HTMLUtil.isDescendant(sel.anchorNode, parent) || !HTMLUtil.isDescendant(sel.focusNode, parent)) {
					return;
				}

				if (this.correctedSelectionRange && HTMLUtil.isRangeEqual(sel.getRangeAt(0), this.correctedSelectionRange)) {
					return;
				}

				const originalRange = sel.getRangeAt(0);

				const surroundings = HTMLUtil.getRangeSurroundings(originalRange, parent);
				if (!surroundings) {
					return;
				}

				sel.removeAllRanges();

				const range = document.createRange();

				// *** move start if it's not at a word boundary ***
				let cursor = new Cursor(surroundings.start.textContent, surroundings.start.nodesByChar, surroundings.start.offset);

				// see if we're on a space
				if (cursor.isWhiteSpace) {
					while (cursor.canMoveForward && cursor.isWhiteSpace) {
						cursor.forward();
					}
				} else {
					while (cursor.canMoveBackward && !cursor.isWhiteSpaceAt(-1) && cursor.isSameContainerAt(-1)) {
						cursor.backward();
					}
				}

				if (Math.abs(cursor.moved) > 12) {
					logger.info('issue moving, going back to where we started');
					cursor.reset();
				}

				range.setStart(surroundings.start.nodesByChar[cursor.position], surroundings.start.offsetsByChar[cursor.position]);

				// *** move end if it's not at a word boundary ***
				cursor = new Cursor(surroundings.end.textContent, surroundings.end.nodesByChar, surroundings.end.offset);

				// see if we're on a space
				if (cursor.isWhiteSpace) {
					while (cursor.canMoveBackward && cursor.isWhiteSpace) {
						cursor.backward();
					}
				} else {
					while (cursor.canMoveForward && !cursor.isWhiteSpaceAt(1) && cursor.isSameContainerAt(1)) {
						cursor.forward();
					}
				}

				if (Math.abs(cursor.moved) > 12) {
					logger.info('issue moving, going back to where we started');
					cursor.reset();
				}

				range.setEnd(surroundings.end.nodesByChar[cursor.position], surroundings.end.offsetsByChar[cursor.position] + 1);

				sel.addRange(range);

				originalRange.detach();

				this.correctedSelectionRange = range;
			},
			highlightClick(style) {
				if (this.isPromptForExistingHighlight) {
					const current = this.highlights[this.showingPrompt];

					if (style === current.style) {
						if (current.textNote) {
							pubsub.publish('annotation-prompt-to-edit-' + this.id, {
								idx: this.showingPrompt,
								isMobile: this.forceMobile || !breakpoints.isLargeScreen()
							});
						} else {
							// delete, they clicked the X on the current color

							// since indexes are used it might seem the messages sent will result in weird data, but
							// since a change to highlights causes a re-render, all new messages will be sent after this
							// during the render. The one thing we do get is sparse data structures.
							this.highlights.splice(this.showingPrompt, 1);
							this.highlightPositions.splice(this.showingPrompt, 1);

							pubsub.publish('annotation-remove-' + this.id, current);

							pubsub.publish('annotation-position-' + this.id, {
								top: null,
								idx: this.showingPrompt
							});

							pubsub.publish('annotation-content-' + this.id, {
								idx: this.showingPrompt,
								content: null
							});

							this.hidePrompt();
						}
					} else {
						// change color
						this.updateAnnotationStyle(this.showingPrompt, style);
					}
				} else {
					// not modifying, this is for a new highlight
					if (!this.isTextSelected) {
						this.hidePrompt();
						return;
					}

					this.selectWholeWords();

					// check again in case something went wrong and selectWholeWords created a
					// 0 length selection (shouldn't happen but we don't want to crash, ever)
					if (!this.isTextSelected) {
						this.hidePrompt();
						return;
					}

					if (this.showingPrompt === null) {
						logger.error('showingPrompt is null during new highlight creation');
						this.showingPrompt = this.highlights.length;
					}

					Store.save('defaultNoteStyle', style);

					this.addNewHighlight(window.getSelection().getRangeAt(0), style);
				}
			},
			noteClick() {
				if (!this.isPromptForExistingHighlight) {
					this.highlightClick(Store.load('defaultNoteStyle') || this.defaultStyle);

					if (this.showingPrompt === null) {
						// this is a known case. Student switches to question or vocab tab with the
						// prompt open. We don't get an event that the selection changed so the
						// prompt stays open with nothing selected. Just close the prompt and
						// return, nothing to see here.
						this.hidePrompt();
						return;
					}
				}

				if (!this.highlights || !this.highlights[this.showingPrompt]) {
					logger.info('showingPrompt is', this.showingPrompt, 'have', this.highlights.length, 'highlights');
					logger.error('Invalid highlighting noteClick');
					this.hidePrompt();
					return;
				}

				pubsub.publish('annotation-prompt-to-edit-' + this.id, {
					idx: this.showingPrompt,
					isMobile: this.forceMobile || !breakpoints.isLargeScreen()
				});
			},
			updateAnnotationStyle(idx, style) {
				const current = this.highlights[idx];
				const positionInfo = this.highlightPositions[idx];

				$('.marking[data-selection-id="' + positionInfo.selectionId + '"]', this.$el)
					.removeClass('marking-' + current.style)
					.addClass('marking-' + style);
				current.style = style;

				pubsub.publish('annotation-update-' + this.id, current);

				Store.save('defaultNoteStyle', style);
			},
			maybeNewHighlight() {
				if (!this.allowEdit) {
					this.hidePrompt();
					return;
				}

				const sel = window.getSelection();
				// not using trim() here because we want to let selectWholeWords decide what do
				// do about whitespace
				if (!sel.toString()) {
					this.hidePrompt();
					return;
				}

				this.selectWholeWords();

				// check again because we may have no selection now, we use trim() now
				// because we don't want only spaces.
				if (!sel.toString().trim()) {
					this.hidePrompt();
					return;
				}

				const range = sel.getRangeAt(0);

				// make sure the selection is contained within the element
				if (!HTMLUtil.isDescendant(range.startContainer, this.$el) || !HTMLUtil.isDescendant(range.endContainer, this.$el)) {
					this.hidePrompt();
					return;
				}

				this.showingPrompt = this.highlights.length;

				this.positionPromptAround(sel);
			},
			maybeNewHighlightHandler: _.debounce(function () {
				if (!window.getSelection().toString()) {
					return;
				}
				this.maybeNewHighlight();
			}, 500),
			promptEditExistingHighlightHandler(event) {
				const isMarkingElement = event.target.classList.contains('marking');

				if (window.getSelection().toString() && !isMarkingElement) {
					return;
				}
				this.promptEditExistingHighlight(event);
			},
			maybeUpdatePromptHandler() {
				if (this.showingPrompt === null) {
					return;
				} else if (this.showingPrompt >= this.highlights.length) {
					this.maybeNewHighlight();
				} else {
					this.promptEditExistingHighlight();
				}
			},
			clickOutClosePromptHandler(event) {
				const selectionContent = window.getSelection().toString();

				// the click on the .marking has to propagate so that vocab word clicks work
				// so if the user just clicked a .marker/x-marker then they clicked a marker
				// and that doesn't qualify as a click out
				const target = event.target;
				const isMarkingElement = target.classList.contains('marking') || target.localName === 'x-marker';
				if (!isMarkingElement && (!selectionContent || !HTMLUtil.isDescendant(event.target, this.$el))) {
					this.hidePrompt();
				}
			},
			flagTouchEventsHandler() {
				this.mobileFlagTriggered = true;
			},
			onFontSizeChange() {
				const height = this.$el.getBoundingClientRect().height;

				if (this.lastElHeight === undefined) {
					this.lastElHeight = height;
				} else if (this.lastElHeight !== height) {
					this.lastElHeight = height;
					if (height !== 0) {
						// keep alive results in 0 height
						this.updateTops();
					}
				}
			}
		},
		watch: {
			content(value) {
				this.converter = new HTMLUtil.RangeConverter(this.$refs.content, value || '');
				this.hidePrompt();
			},
			highlights: 'renderAllHighlights',
			splitScreen: 'updateTops'
		},
		created() {
			const id = `highlighting-${idCounter++}`;
			this.id = id;

			this.unsubUpdateStyle = pubsub.subscribe(`annotation-set-style-${id}`, params => {
				this.updateAnnotationStyle(params.idx, params.style);
			});

			this.unsubPrompt = pubsub.subscribe(`annotation-prompt-${this.id}`, idx => {
				this.positionPromptAround(idx);
			});

			this.unsubFontSize = pubsub.subscribe('font-size-changed', this.onFontSizeChange);

			// we also need some custom events
			document.addEventListener('selectionchange', this.maybeNewHighlightHandler);
			document.addEventListener('mouseup', this.maybeNewHighlightHandler);
			document.addEventListener('click', this.clickOutClosePromptHandler);

			// in mobile safari you don't get a click at all if you touch to the right
			// or left of the content
			document.addEventListener('touchend', this.clickOutClosePromptHandler);
			document.addEventListener('touchstart', this.flagTouchEventsHandler);

			optimizedResize.add(this.maybeUpdatePromptHandler);
			// optimized resize does not capture very fast changes
			// edge case — using native to prevent regression
			window.addEventListener('resize', this.updateTops);
		},
		mounted() {
			// v-html preferred but marklib causes de-sync with VDOM
			this.$refs.content.innerHTML = this.content;
			this.converter = new HTMLUtil.RangeConverter(this.$refs.content, this.content || '');
			this.updateTops();
		},
		beforeDestroy() {
			this.unsubUpdateStyle();
			this.unsubPrompt();
			this.unsubFontSize();

			document.removeEventListener('selectionchange', this.maybeNewHighlightHandler);
			document.removeEventListener('mouseup', this.maybeNewHighlightHandler);
			document.removeEventListener('click', this.clickOutClosePromptHandler);
			document.removeEventListener('touchend', this.clickOutClosePromptHandler);
			document.removeEventListener('touchstart', this.flagTouchEventsHandler);

			optimizedResize.remove(this.maybeUpdatePromptHandler);
			window.removeEventListener('resize', this.updateTops);
		}
	};
</script>
<style lang="scss"></style>
<template>
	<div
		class="highlighting"
		@click="promptEditExistingHighlightHandler">
		<div ref="content"></div>
		<highlighting-prompt
			ref="prompt"
			:highlight-click="highlightClick"
			:note-click="noteClick"
			:minimal="minimal"
			:force-mobile="mobileFlagTriggered">
		</highlighting-prompt>
		<div class="annotation-mobile-flag"></div>
	</div>
</template>
